import { useQuery } from "@tanstack/react-query";
import { stageGateApi } from "../../stageGates/api/service";
import { queryClient } from "../../../shared/providers/QueryProvider";

export const useFetchTaskDetails = ({ taskId }: { taskId: string; }) => {

    const { data, isFetching, isPending, isLoading, isError, error, refetch } = useQuery({
        queryKey: ["tasks-details", taskId],
        queryFn: () => stageGateApi.fetchCheckListsDetails(taskId),
        enabled: !!taskId,
    });

    return {
        taskDetails: data?.data || [],
        isPending: isPending || isFetching || isLoading,
        isFetching, isError, error,
        refetch, removeCache: () => {
            queryClient.removeQueries({ queryKey: ["tasks-details", taskId] });
        }
    };

}